import React from 'react'
import { useCallback, useFeatures, useAbValues, useMemo } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import { constants } from 'common/helpers'
import actions from 'redux/actions'

import Box from 'components/_new/layout/Box/Box'
import FixedSidebar from 'components/_new/FixedSidebar/FixedSidebar'
import NavList from 'components/_new/NavList/NavList'

import s from './SidebarNav.scss'
import { getNav } from './util'


const SidebarNav = () => {
  const { isSubscriptionCancelled, isOpened, pathname, notEmptyTypes, skincareStructure, navigation } = useConnect({
    isOpened: 'models.ui.isSideMenuVisible',
    isSubscriptionCancelled: 'models.subscription.isCancelled',
    pathname: 'routing.location.pathname',
    notEmptyTypes: 'view.cosmeticsPage.notEmptyTypes',
    skincareStructure: 'view.cosmeticsPage.structure',
    navigation: 'models.navigation',
  })

  const {
    [constants.features.productsCollections]: isCollectionsEnabled,
    [constants.features.incubatorNeonHeat]: isIncubatorNeonHeatEnabled,
    [constants.features.resubscribeMembershipPage]: isResubscribeMembershipPageEnabled,
    [constants.features.fatherDayBambooGiftSet]: isFatherDayBambooGiftSetEnabled,
    [constants.features.hidePopularInStates]: isPopularInStatesHidden,
    [constants.features.hideFragranceFinder]: isFragranceFinderHidden,
    [constants.features.hideFragranceHoroscope]: isFragranceHoroscopeHidden,
    [constants.features.hideGifts]: isGiftsHidden,
    [constants.features.separateWellness]: isSeparateWellnessEnabled,
  } = useFeatures()

  const resubscribeBurgerMenuAbValue = useAbValues(constants.abTests.resubscribeBurgerMenu)

  const nav = useMemo(() => getNav({
    notEmptyTypes,
    structure: skincareStructure,
    navigation,
    isSubscriptionCancelled,
    resubscribeBurgerMenuAbValue,
    isCollectionsEnabled,
    isIncubatorNeonHeatEnabled,
    isResubscribeMembershipPageEnabled,
    isFatherDayBambooGiftSetEnabled,
    isPopularInStatesHidden,
    isFragranceFinderHidden,
    isFragranceHoroscopeHidden,
    isGiftsHidden,
    isSeparateWellnessEnabled,
  }), [
    notEmptyTypes,
    skincareStructure,
    navigation,
    isSubscriptionCancelled,
    resubscribeBurgerMenuAbValue,
    isCollectionsEnabled,
    isIncubatorNeonHeatEnabled,
    isResubscribeMembershipPageEnabled,
    isFatherDayBambooGiftSetEnabled,
    isPopularInStatesHidden,
    isFragranceFinderHidden,
    isFragranceHoroscopeHidden,
    isGiftsHidden,
    isSeparateWellnessEnabled,
  ])

  const close = useCallback(() => {
    actions.models.ui.closeSideMenu()
  }, [])

  return (
    <FixedSidebar className={s.sideMenu} isOpened={isOpened}>
      <Box mt="16">
        <NavList items={nav} pathname={pathname} minSubNavLengthToDisplay={2} closeNav={close} />
      </Box>
    </FixedSidebar>
  )
}


export default SidebarNav
